import React from "react";
import { Menu, Row } from "antd";
import { ErrorDropdownIcon } from "../../../../assets/svg";
import "./styles.scss";

const EmptyOption = ({ emptyText, style = {} }) => (
  <Menu.Item
    style={style}
    key="empty"
    value="empty"
    className="unclickable-option empty-slate"
  >
    <Row className="error-icon" justify="center" align="middle">
      <ErrorDropdownIcon />
    </Row>
    <Row style={{ marginTop: 16 }} justify="center" align="middle">
      <p
        style={{
          width: "100%",
          whiteSpace: "normal",
          lineHeight: "2rem",
          textAlign: "center",
        }}
      >
        {emptyText}
      </p>
    </Row>
  </Menu.Item>
);

export default EmptyOption;
